var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"myBiaoZhu",attrs:{"id":'myBiaoZhuDiv' + _vm.idx || 0}},[_c('img',{ref:"direcrDel",staticStyle:{"height":"100%","width":"100%"},attrs:{"id":'myBiaoZhu' + _vm.idx || 0,"src":_vm.imgUrl,"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }